/**
* @name: user-recent-menu-list
* @author: weiyong
* @date: 2024-10-08 23:35
* @description：user-recent-menu-list
* @update: 2024-10-08 23:35
*/
<template>
  <div class="user-recent-menu-list flex-div flex-wrap">
    <template v-if="menuList.length>0">
      <div  class="common-menu-li w100b" v-for="item in menuList">
        <menu-li-record :isCollectItemFlag="isCollectItem(item)"    @click="selActiveOneMenu(item)" :item="item"/>
      </div>
    </template>
    <a-empty v-else/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "user-recent-menu-list",
});
</script>

<script lang="ts" setup>
import MenuLiRecord from "@/layouts/layoutFrame/military/components/menu-li-record.vue";
import {useUserRecentMenu} from "@/layouts/layoutFrame/military/hooks/useUserRecentMenu";

const props=defineProps({
  collectMenuList:{}
})
const {menuList,selActiveOneMenu}=useUserRecentMenu();

//判断是否已经收藏的菜单
const isCollectItem = (item) => {
  if(unref(menuList)&&unref(menuList).length>0){
    const colItem=unref(menuList).filter((itemDb)=>{
      return item.id===itemDb.id;
    })[0];
    if(colItem){
      return  true
    }
  }
  return false
}
</script>

<style type="text/css" lang="less">
.user-recent-menu-list{
  .common-menu-li {
    width:175px;
    margin-right: 12px;
    margin-top: var(--base-com-top-margin,12px);
    cursor:pointer;
    height: 38px;
  }
}
</style>
